import React from 'react'

const reset_view = () => {
  const buttonStyle = {
    position: "absolute", /* Position relative to #map-container */
    top: "30px",
    right:"30px",
    zIndex: "10", /* Ensure it's above the map */
  }

  return (
    <button style={buttonStyle} id="reset_view" className="btn btn-primary">
      Reset View
    </button>
  )
}

export default reset_view
